import { render, staticRenderFns } from "./app.vue?vue&type=template&id=3574dabf&scoped=true&"
import script from "./app.vue?vue&type=script&lang=coffee&"
export * from "./app.vue?vue&type=script&lang=coffee&"
import style0 from "./app.vue?vue&type=style&index=0&id=3574dabf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3574dabf",
  null
  
)

export default component.exports